import React, { useEffect } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import AnimatedBackground from '../components/AnimatedBackground';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { setPageMeta } from '../utils/seo';
import './Career.css';

const ExploreCareers = () => {
  useEffect(() => {
    setPageMeta(
      'Careers at Sapiencia.AI',
      'Explore open roles and opportunities to build secure AI for healthcare and defense.'
    );
  }, []);

  return (
    <div className="careers">
      <AnimatedBackground />
      <Navbar />

      <div className="careers-container">
        {/* Hero Section */}
        <header className="careers-hero">
          <motion.div
            className="careers-hero-content"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1 }}
          >
            <h1>Join Our Team and Shape the Future</h1>
            <p>We’re looking for passionate individuals to build innovative solutions with us.</p>
            <div className="separator"></div>
          </motion.div>
        </header>

        {/* Careers List Section */}
        <section className="careers-list">
          <div className="careers-grid">
            {[
              {
                title: "DevOps Engineer",
                desc: "Seamless collaboration between software development and IT operations."
              },
              {
                title: "UI/UX Designer",
                desc: "Design seamless user experiences and stunning visuals."
              },
              {
                title: "Data Scientist",
                desc: "Leverage AI and big data to drive insights."
              },
              {
                title: "Marketing Specialist",
                desc: "Create impactful campaigns to grow our brand."
              }
            ].map((career, index) => (
              <motion.div
                className="career-card"
                key={index}
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, delay: index * 0.2 }}
                viewport={{ once: false, amount: 0.3 }}
                whileHover={{ y: -8 }}
              >
                <h2>{career.title}</h2>
                <p>{career.desc}</p>
              </motion.div>
            ))}
          </div>
        </section>

        {/* CTA Section */}
        <section className="careers-cta">
          <motion.div
            className="cta-content"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: false, amount: 0.3 }}
          >
            <h2>Be a Part of Something Bigger</h2>
            <p>We invite you to bring your talent, passion, and curiosity to our team and help shape the future.</p>
            <div className="cta-buttons">
              <Link to="/about" className="cta-button">About Us</Link>
              <Link to="/contact" className="outline-button">Contact Us</Link>
            </div>
          </motion.div>
        </section>
      </div>

      {/* Shared Footer */}
      <Footer />
    </div>
  );
};

export default ExploreCareers;
